import React from 'react'

const className = 'abcdefghiklmnopqrstuvwxyz'

const Photo = ({ number, photo, onClick }) => {

    const handleClick = (event) => {
        onClick(event, { photo, number });
    }

    return (
        <div className={`fill ${className[number]}`}>
            <div>
                <img {...photo} onClick={onClick ? handleClick : null} alt={number} />
            </div>
        </div>
    );
};

export default Photo
